var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:assets' to update
import Asset from '../asset-internal';
function AzureLogomark(_a) {
    var restProps = __rest(_a, []);
    return (_jsx(Asset, Object.assign({ viewBox: "0 0 30 23" }, restProps, { children: _jsx("path", { d: "M13.421 21.654c2.281-.402 4.562-.806 6.842-1.211l.064-.014-3.519-4.186a601.106 601.106 0 0 1-3.519-4.205c0-.02 3.634-10.027 3.654-10.063.007-.011 2.48 4.258 5.994 10.35a105879 105879 0 0 1 6.029 10.449l.046.08-11.184-.002-11.183-.001 6.777-1.197ZM0 20.377c0-.006 1.658-2.884 3.685-6.396l3.684-6.386 4.295-3.603c2.361-1.982 4.3-3.607 4.308-3.61a.751.751 0 0 1-.07.174c-.045.099-2.143 4.6-4.662 10.001L6.66 20.38l-3.33.005C1.5 20.386 0 20.383 0 20.377Z", fill: "currentColor" }) })));
}
export default AzureLogomark;
